// src/pages/ResetPassword.jsx

import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "../api";
import "../theme/design.css";

export default function ResetPassword(){

  const [params] = useSearchParams();
  const navigate = useNavigate();

  const token = params.get("token");

  const [password,setPassword] = useState("");
  const [msg,setMsg] = useState("");

  const reset = async () => {
    try{

      await api.post("/reset-password",{
        token,
        password
      });

      setMsg("Password reset successful");

      setTimeout(()=>{
        navigate("/login");
      },1500);

    }catch(e){
      setMsg("Reset failed or link expired");
    }
  };

  return (
    <div className="page">
      <div className="post-card">

        <h2>Reset Password</h2>

        <input
          className="input"
          type="password"
          placeholder="New password"
          value={password}
          onChange={(e)=>setPassword(e.target.value)}
        />

        <button className="btn" onClick={reset}>
          Reset Password
        </button>

        {msg && <div style={{marginTop:10}}>{msg}</div>}

      </div>
    </div>
  );
}